import { identityConfig } from "../../../auth/authConst";

export namespace TokenHelper {

    function getOidcStorage(): any {
        const item = sessionStorage.getItem(
            `oidc.user:${identityConfig.authority}:${identityConfig.client_id}`
        );

        return item != null ? JSON.parse(item) : null;
    };


    export function getClaims() {
        const oidcStorage = getOidcStorage();
        const userToken = oidcStorage?.profile;
        return userToken;
    }

    //function getIdTokenClaims() {
    //    const oidcStorage = JSON.parse(
    //        sessionStorage.getItem(
    //            `oidc.user:${identityConfig.authority}:${identityConfig.client_id}`
    //        )
    //    );
    //    const idToken = oidcStorage?.id_token;
    //    const decodedIdToken = idToken && jwtDecode(idToken);

    //    return decodedIdToken;
    //}

    export function getAccessToken() : any | undefined{
        const oidcStorage = getOidcStorage();
        const access_token = oidcStorage?.access_token;

        return access_token;
    }

    export function getRefreshToken(): any | undefined{
        const oidcStorage = getOidcStorage();
        const refresh_token = oidcStorage?.refresh_token;

        return refresh_token;
    }


    export function updateStorageProfile(profile: any) {
        const oidcStorage = getOidcStorage();
        oidcStorage["profile"] = profile;
        sessionStorage.setItem(`oidc.user:${identityConfig.authority}:${identityConfig.client_id}`, JSON.stringify(oidcStorage));
    }

}
